import React, { FC, useState, useEffect } from 'react';
import useEEActive from '../../../hooks/useEEActive';
import './styles.scss';
import { windowService } from '../../../utils/window.utils.js';
import { EventEnum } from '../../../enums/event.enum';
import Spinner from '../spinner';

const Loader: FC<{}> = () => {
  const isEEActive = useEEActive();
  const [showLoader, setShowLoader] = useState<boolean[]>([]);

  useEffect(() => {
    const addLoderQueueItemListener = () => setShowLoader((prev) => [...prev, true]);
    const removeLoderQueueItemListener = () => setShowLoader((prev) => [...prev].slice(0, -1));

    windowService().addEventListener(EventEnum.ADD_LOADER_QUEUE_ITEM, addLoderQueueItemListener);
    windowService().addEventListener(EventEnum.REMOVE_LOADER_QUEUE_ITEM, removeLoderQueueItemListener);

    return () => {
      windowService().removeEventListener(EventEnum.ADD_LOADER_QUEUE_ITEM, addLoderQueueItemListener);
      windowService().removeEventListener(EventEnum.REMOVE_LOADER_QUEUE_ITEM, removeLoderQueueItemListener);
    };
  }, []);

  if (isEEActive) return null;

  return (
    <div className={`loader ${showLoader.length > 0 ? 'loader--show' : ''}`}>
      <Spinner />
    </div>
  );
};

export default Loader;
